import React from 'react';

const CGU = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      <div className="container max-w-4xl mx-auto px-4 py-8">
        {/* Header */}
        <h1 className="text-4xl font-bold mb-4 text-gray-900 dark:text-white">
          Conditions Générales d'Utilisation
        </h1>

        <p className="text-sm text-gray-500 dark:text-gray-400 mb-8">
          Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
        </p>

        {/* Article 1 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Article 1 - Objet
          </h2>
          <p className="mb-4 leading-relaxed text-gray-700 dark:text-gray-300">
            Les présentes Conditions Générales d'Utilisation (CGU) régissent l'accès et
            l'utilisation de la plateforme Remadia Health, accessible à l'adresse [URL]. Remadia
            Health est un service d'information et d'assistance médicale à destination des seniors,
            aidants et professionnels de santé en France.
          </p>
        </section>

        {/* Article 2 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Article 2 - Éditeur du service
          </h2>
          <div className="space-y-2 text-gray-700 dark:text-gray-300">
            <p>
              <strong>Éditeur :</strong> Alcantara Rémi
            </p>
            <p>
              <strong>Siège social :</strong> 173 rue de Courcelles, 75017 Paris, France
            </p>
            <p>
              <strong>SIRET :</strong> 53169357000040
            </p>
            <p>
              <strong>Email :</strong> contact@remadia.com
            </p>
            <p>
              <strong>Hébergeur :</strong> Vercel Inc., 340 S Lemon Ave #4133, Walnut, CA 91789, USA
            </p>
          </div>
        </section>

        {/* Article 3 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Article 3 - Acceptation des CGU
          </h2>
          <p className="mb-4 leading-relaxed text-gray-700 dark:text-gray-300">
            L'utilisation de Remadia Health implique l'acceptation pleine et entière des présentes
            CGU. L'utilisateur reconnaît avoir pris connaissance des CGU et les accepte sans
            réserve.
          </p>
        </section>

        {/* Article 4 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Article 4 - Nature du service
          </h2>
          <div className="bg-yellow-50 dark:bg-yellow-900/20 border-l-4 border-yellow-400 p-4 mb-4">
            <p className="font-bold text-gray-900 dark:text-white">IMPORTANT :</p>
            <p className="text-gray-700 dark:text-gray-300">
              Remadia Health est un outil d'information et d'assistance à visée éducative. Il ne se
              substitue EN AUCUN CAS à une consultation médicale, un diagnostic ou un traitement
              prescrit par un professionnel de santé qualifié.
            </p>
          </div>

          <p className="mb-2 text-gray-700 dark:text-gray-300">Le service comprend :</p>
          <ul className="list-disc list-inside space-y-2 ml-4 text-gray-700 dark:text-gray-300">
            <li>Un chatbot d'assistance médicale basé sur l'intelligence artificielle</li>
            <li>Une base de données de médicaments à titre informatif</li>
            <li>Des ressources d'urgence (pharmacies, hôpitaux)</li>
            <li>Un forum communautaire pour aidants</li>
            <li>Des articles médicaux à visée éducative</li>
          </ul>
        </section>

        {/* Article 5 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Article 5 - Limitation de responsabilité
          </h2>

          <div className="space-y-4 text-gray-700 dark:text-gray-300">
            <div>
              <h3 className="font-semibold mb-2">5.1 Responsabilité médicale</h3>
              <p className="leading-relaxed">
                L'éditeur ne peut être tenu responsable des décisions médicales prises sur la base
                des informations fournies. En cas d'urgence médicale, contactez immédiatement le 15
                (SAMU) ou le 112.
              </p>
            </div>

            <div>
              <h3 className="font-semibold mb-2">5.2 Exactitude des informations</h3>
              <p className="leading-relaxed">
                Bien que nous nous efforcions de fournir des informations exactes et à jour, nous ne
                garantissons pas l'exhaustivité, l'exactitude ou la pertinence des contenus. Les
                informations médicales évoluent constamment.
              </p>
            </div>

            <div>
              <h3 className="font-semibold mb-2">5.3 Utilisation de l'IA</h3>
              <p className="leading-relaxed">
                Les réponses générées par l'intelligence artificielle peuvent contenir des erreurs.
                Elles doivent être considérées comme indicatives et non comme des avis médicaux
                définitifs.
              </p>
            </div>
          </div>
        </section>

        {/* Article 6 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Article 6 - Inscription et compte utilisateur
          </h2>
          <p className="mb-4 leading-relaxed text-gray-700 dark:text-gray-300">
            L'accès à certaines fonctionnalités nécessite la création d'un compte via Google
            Authentication.
          </p>
          <p className="mb-2 text-gray-700 dark:text-gray-300">L'utilisateur s'engage à :</p>
          <ul className="list-disc list-inside space-y-2 ml-4 text-gray-700 dark:text-gray-300">
            <li>Fournir des informations exactes</li>
            <li>Maintenir la confidentialité de ses identifiants</li>
            <li>Ne pas partager son compte</li>
            <li>Informer immédiatement en cas d'utilisation non autorisée</li>
          </ul>
        </section>

        {/* Article 7 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Article 7 - Quotas et limitations
          </h2>
          <p className="mb-2 text-gray-700 dark:text-gray-300">
            Les utilisateurs gratuits disposent de :
          </p>
          <ul className="list-disc list-inside space-y-2 ml-4 mb-4 text-gray-700 dark:text-gray-300">
            <li>3 recherches IA par jour</li>
            <li>Accès limité à certaines fonctionnalités</li>
          </ul>
          <p className="text-gray-700 dark:text-gray-300">
            Les utilisateurs premium bénéficient d'un accès illimité selon leur forfait.
          </p>
        </section>

        {/* Article 8 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Article 8 - Propriété intellectuelle
          </h2>
          <p className="leading-relaxed text-gray-700 dark:text-gray-300">
            Tous les contenus présents sur Remadia Health (textes, images, logos, design) sont
            protégés par le droit d'auteur. Toute reproduction, distribution ou utilisation
            commerciale sans autorisation est interdite.
          </p>
        </section>

        {/* Article 9 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Article 9 - Utilisation acceptable
          </h2>
          <p className="mb-2 text-gray-700 dark:text-gray-300">L'utilisateur s'interdit de :</p>
          <ul className="list-disc list-inside space-y-2 ml-4 text-gray-700 dark:text-gray-300">
            <li>Utiliser le service à des fins illégales</li>
            <li>Tenter de contourner les limitations techniques</li>
            <li>Diffuser des contenus offensants, diffamatoires ou inappropriés sur le forum</li>
            <li>Extraire ou copier massivement les données du service</li>
            <li>Usurper l'identité d'un professionnel de santé</li>
          </ul>
        </section>

        {/* Article 10 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Article 10 - Modification du service
          </h2>
          <p className="leading-relaxed text-gray-700 dark:text-gray-300">
            L'éditeur se réserve le droit de modifier, suspendre ou interrompre tout ou partie du
            service à tout moment, avec ou sans préavis.
          </p>
        </section>

        {/* Article 11 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Article 11 - Modification des CGU
          </h2>
          <p className="leading-relaxed text-gray-700 dark:text-gray-300">
            Les CGU peuvent être modifiées à tout moment. Les utilisateurs seront informés des
            modifications majeures. L'utilisation continue du service après modification vaut
            acceptation des nouvelles CGU.
          </p>
        </section>

        {/* Article 12 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Article 12 - Droit applicable et juridiction
          </h2>
          <p className="leading-relaxed text-gray-700 dark:text-gray-300">
            Les présentes CGU sont soumises au droit français. En cas de litige, et à défaut
            d'accord amiable, les tribunaux français seront seuls compétents.
          </p>
        </section>
      </div>
    </div>
  );
};

export default CGU;
